import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import DeliveryLiveTracker from "./DeliveryLiveTracker";


export default function DeliveryDashboard() {
  const navigate = useNavigate();
  const [paymentSummary, setPaymentSummary] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const [baseSalary, setBaseSalary] = useState(0);
  const [cashNotes, setCashNotes] = useState([]);
  const [showCashNotes, setShowCashNotes] = useState(false);

  const [orders, setOrders] = useState([]);
  const [summary, setSummary] = useState(null);
  const [cashSummary, setCashSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  const [profile, setProfile] = useState({
    name: "",
    phone: "",
  });

  /* ---------------- LOAD PROFILE ---------------- */
  const loadProfile = async () => {
    try {
      const res = await axios.get("/user-info/");
      setProfile({
        name: res.data.name || "Delivery Partner",
        phone: res.data.phone || "",
      });
    } catch {
      console.error("Failed to load profile");
    }
  };
const loadCashNotes = async () => {
  try {
    const res = await axios.get("/delivery/cash-notes/");
    setCashNotes(res.data.notes || []);
  } catch {
    console.error("Failed to load cash notes");
  }
};
const toggleNotes = () => {
  if (!showNotes) {
    loadCashNotes();
  }
  setShowNotes(!showNotes);
};

const loadPaymentSummary = async () => {
  try {
    const res = await axios.get("/delivery/payment-summary/");
    setPaymentSummary(res.data);
  } catch (err) {
    console.error("Failed to load payment summary", err);
  }
};

  /* ---------------- LOAD DASHBOARD ---------------- */
  const loadDashboard = async () => {
    try {
      const res = await axios.get("/delivery/dashboard-summary/");
      setSummary(res.data.summary);
      setOrders(res.data.orders || []);
    } catch (err) {
      console.error("Dashboard load failed", err);
    }
  };

  /* ---------------- LOAD CASH ---------------- */
  const loadCash = async () => {
    try {
      const res = await axios.get("/delivery/cash-history/");
      setCashSummary(res.data.summary);
    } catch (err) {
      console.error("Cash history load failed", err);
    }
  };
const loadBaseSalary = async () => {
  try {
    const res = await axios.get("delivery/get-base-salary/");
    setBaseSalary(res.data.base_salary || 0);
  } catch {
    setBaseSalary(0);
  }
};

  /* ---------------- ACCEPT ORDER ---------------- */
  const acceptOrder = async (orderId) => {
    try {
      await axios.post("/delivery/accept-order/", { order_id: orderId });
      alert("Order accepted");
      loadDashboard();
    } catch (err) {
      alert(err.response?.data?.error || "Accept order failed");
    }
  };

  /* ---------------- CONFIRM CASH ---------------- */
  const confirmCash = async (orderId) => {
    try {
      await axios.post("/delivery/confirm-cash/", { order_id: orderId });
      alert("Cash collected");
      loadDashboard();
      loadCash();
    } catch (err) {
      alert(err.response?.data?.error || "Cash confirmation failed");
    }
  };

  /* ---------------- MARK DELIVERED ---------------- */
  const markDelivered = async (orderId) => {
    try {
      await axios.post("/delivery/mark-order/", {
        order_id: orderId,
        action: "delivered",
      });
      alert("Order marked delivered");
      loadDashboard();
    } catch (err) {
      alert(err.response?.data?.error || "Delivery failed");
    }
  };

  /* ---------------- RETURN ORDER ---------------- */
  const returnOrder = async (orderId) => {
    const reason = prompt("Enter return reason");
    if (!reason) return;

    try {
      await axios.post("/delivery/mark-order/", {
        order_id: orderId,
        action: "returned",
        reason,
      });
      alert("Order returned");
      loadDashboard();
    } catch (err) {
      alert(err.response?.data?.error || "Return failed");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    Promise.all([loadProfile(), loadDashboard(), loadCash(),loadPaymentSummary(),	]).finally(() =>
      setLoading(false)
    );
  }, []);
useEffect(() => {
  loadPaymentSummary(); // pending, total_received
  loadBaseSalary();
}, []);

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  return (
    <div style={page}>

<DeliveryLiveTracker />
      {/* HEADER */}
      <div style={header}>
        <div style={profileBox}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt="avatar"
            style={avatar}
          />
          <div>
            <div style={{ fontWeight: "bold" }}>{profile.name}</div>
            <div style={{ fontSize: 13, color: "#555" }}>{profile.phone}</div>
          </div>
        </div>

        <button onClick={handleLogout} style={logoutBtn}>
          Logout
        </button>
      </div>

      {/* SUMMARY */}
{/* SUMMARY GRID */}
<div style={cardGrid}>
  <SummaryCard title="Assigned" value={summary.assigned_orders} />
  <SummaryCard title="Delivered" value={summary.completed_orders} />
  <SummaryCard title="Returned" value={summary.returned_orders} />
  <SummaryCard
    title="Pending Cash"
    value={`₹${cashSummary?.pending_cash || 0}`}
  />
  <SummaryCard
    title="Delivery Earning"
    value={`₹${summary?.delivery_earning || 0}`}
  />
  <SummaryCard
    title="Amount Received"
    value={`₹${paymentSummary?.total_received || 0}`}
  />
  <SummaryCard
    title="Pending Amount"
    value={`₹${paymentSummary?.pending_amount || 0}`}
  />
<SummaryCard
 title="Base Salary"
 value={`₹${baseSalary || 0}`}
/>
</div>

{/* ✅ ADMIN NOTES — OUTSIDE GRID */}
{paymentSummary?.admin_notes?.length > 0 && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: 24,
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "720px", // 🔥 wider
        background: "#e0f2fe",
        padding: "18px 22px",
        borderRadius: 14,
        boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
        cursor: "pointer",
      }}
      onClick={() => setShowNotes(!showNotes)}
    >
      <div
        style={{
          fontWeight: "bold",
          fontSize: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: showNotes ? 12 : 0,
        }}
      >
        <span>📌 Admin Notes</span>
        <span>{showNotes ? "▲" : "▼"}</span>
      </div>

      {showNotes && (
        <div>
          {paymentSummary.admin_notes.map((n, i) => (
            <div
              key={i}
              style={{
                padding: "10px 0",
                borderBottom:
                  i !== paymentSummary.admin_notes.length - 1
                    ? "1px dashed #94a3b8"
                    : "none",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 14 }}>
                {new Date(n.created_at).toLocaleString()}
              </div>
              <div style={{ fontSize: 14 }}>
                ₹{n.amount} — {n.note}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
)}

{/* 💰 COD SETTLEMENT NOTES — SEPARATE SCROLL */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: 16,
  }}
>
  <div
    style={{
      width: "100%",
      maxWidth: "720px",
      background: "#ecfeff",
      padding: "18px 22px",
      borderRadius: 14,
      boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
      cursor: "pointer",
    }}
    onClick={() => {
      if (!showCashNotes) loadCashNotes();
      setShowCashNotes(!showCashNotes);
    }}
  >
    <div
      style={{
        fontWeight: "bold",
        fontSize: 16,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: showCashNotes ? 12 : 0,
      }}
    >
      <span>💰 COD Settlement Notes</span>
      <span>{showCashNotes ? "▲" : "▼"}</span>
    </div>

    {showCashNotes && (
      <div
        style={{
          maxHeight: 260,
          overflowY: "auto",
          paddingRight: 6,
        }}
      >
        {cashNotes.length === 0 && (
          <p style={{ fontSize: 13, color: "#6b7280" }}>
            No COD settlement notes yet
          </p>
        )}

        {cashNotes.map((n, i) => (
          <div
            key={i}
            style={{
              padding: "10px 12px",
              marginBottom: 8,
              background: "#fff",
              borderRadius: 8,
              border: "1px solid #e5e7eb",
            }}
          >
            <div style={{ fontSize: 12, color: "#64748b" }}>
              {n.datetime}
            </div>
            <div style={{ marginTop: 4, fontSize: 14 }}>
              {n.note}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
</div>



 

      <h2 style={{ marginTop: 20 }}>My Deliveries</h2>

      {orders.length === 0 && <p>No active orders</p>}

      {orders.map((order) => (
        <div key={order.id} style={card}>
          <h3>{order.order_number}</h3>

          <p><b>Status:</b> {order.status}</p>
          <p><b>Address:</b> {order.address}</p>
          <p><b>Customer Phone:</b> {order.customer_phone}</p>
          <p><b>Delivery Income:</b> ₹{order.delivery_charge}</p>

          <p>
            <b>Payment:</b>{" "}
            {order.payment_method === "cod" ? "Cash on Delivery" : "Online"}
          </p>

          <p><b>Payment Status:</b> {order.payment_status}</p>

          {/* ACTIONS */}
          {order.status === "assigned" && (
            <button
              style={cashBtn}
              onClick={() => acceptOrder(order.id)}
            >
              Accept Order
            </button>
          )}

          {order.status === "out_for_delivery" && (
            <>
              {order.payment_method === "cod" && !order.cash_collected && (
                <button
                  style={cashBtn}
                  onClick={() => confirmCash(order.id)}
                >
                  Confirm Cash
                </button>
              )}

              {(order.payment_method !== "cod" || order.cash_collected) && (
                <button
                  style={deliverBtn}
                  onClick={() => markDelivered(order.id)}
                >
                  Mark Delivered
                </button>
              )}

              <button
                style={{ ...cashBtn, background: "#f97316" }}
                onClick={() => returnOrder(order.id)}
              >
                Return
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

/* ---------------- SMALL COMPONENT ---------------- */
const SummaryCard = ({ title, value }) => (
  <div style={summaryCard}>
    <div style={{ fontSize: 13, color: "#555" }}>{title}</div>
    <div style={{ fontSize: 20, fontWeight: "bold" }}>{value}</div>
  </div>
);

/* ---------------- STYLES ---------------- */
const page = { padding: 20, background: "#f1f5f9", minHeight: "100vh" };
const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#fff",
  padding: 16,
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
};
const profileBox = { display: "flex", alignItems: "center", gap: 12 };
const avatar = { width: 50, height: 50, borderRadius: "50%" };
const logoutBtn = {
  background: "#ef4444",
  color: "#fff",
  border: "none",
  padding: "8px 16px",
  borderRadius: 8,
  cursor: "pointer",
};
const cardGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
  gap: 12,
  marginTop: 16,
};
const summaryCard = {
  background: "#fff",
  padding: 14,
  borderRadius: 10,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  textAlign: "center",
};
const card = {
  background: "#fff",
  padding: 16,
  marginTop: 16,
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
};
const cashBtn = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: 6,
  marginRight: 8,
  cursor: "pointer",
};
const deliverBtn = {
  background: "#16a34a",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: 6,
  cursor: "pointer",
};
